import * as v from 'valibot'

export const BillingSummary = v.object({
  points: v.number(),
  playable_turns: v.number(),
  action_prices: v.object({ turn_play: v.number() }),
  stripe_mode: v.picklist(['test', 'live']),
  daily_claim: v.object({
    claimed_today: v.boolean(),
    next_available_at: v.string(),
    points: v.number(),
  }),
})

/**
 * 未登录也能取的注册奖励：顶栏注册按钮和登录弹窗据此展示「注册送多少积分」，0 表示当前没有注册奖励。
 * @typedef {{ points: number }} SignupRewardOfferT
 */
export const SignupRewardOffer = v.object({
  points: v.pipe(v.number(), v.integer(), v.minValue(0)),
})

export const DailyClaimResponse = v.object({
  points: v.number(), claimed: v.boolean(), claimed_today: v.boolean(), next_available_at: v.string(),
})
